import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { ApplicationInfosResponse } from '../types'

export const useUnlinkApplicant = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ applicationId }: { applicationId: number }) => {
      return await fetchApiWithToken<ApplicationInfosResponse>({
        method: 'PATCH',
        url: `/v1/applications/${applicationId}`,
        data: { applicant: null }
      })
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(['applications', variables.applicationId], data)

      queryClient.invalidateQueries({
        queryKey: ['applications']
      })
    }
  })
}
